import './menu_item_editor_generics.less';

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Ol from 'zoomforth_component_lib/ol_with_digits.jsx';
import Tooltip from 'zoomforth_component_lib/tooltip.jsx';
import InputContainer from 'zoomforth_component_lib/input_container.jsx';
import withSmartEmptyError from 'zoomforth_component_lib/with_smart_empty_error.jsx';

import Divider from 'zoomforth_codesbane_editor/exterior_editor/sidebar/shared/divider.jsx';

import SubpageCopyAndDuplicateButtons from '../shared/subpage_copy_buttons_container.jsx';

import LinkEditorGenerics
  from 'zoomforth_codesbane_editor/exterior_editor/sidebar/link_editor/link_editor_generics.jsx';

import TranslationsEditingDisabledDiv
  from 'zoomforth_codesbane_editor/component_lib/translations_editing_disabled_div_container.jsx';

import TranslateTextWidget
  from 'zoomforth_codesbane_editor/exterior_editor/sidebar/shared/translate_text_widget_container.jsx';


const InputContainerSmartEmptyError = withSmartEmptyError(InputContainer);

const MenuItemEditorGenerics = ({
  isValid,
  title,
  sidebarTitle,
  titleInputName,
  canDeleteMenuItem,
  deleteText,
  saveText,
  children,
  shouldShowCopyAndDuplicateBtns,
  temporarySubpage,
  onTitleChange, 
  onDeleteClick,
  onSaveClick,
  onCancelClick
})=> (
  <LinkEditorGenerics
    sidebarTitle={sidebarTitle}
    isValid={!!(title && isValid)}
    saveText={saveText}
    canDeleteLink={canDeleteMenuItem}
    deleteText={deleteText}
    onDeleteClick={onDeleteClick}
    onSaveClick={onSaveClick}
    onCancelClick={onCancelClick}
  >
    {
      (shouldShowCopyAndDuplicateBtns && temporarySubpage) &&
        <Fragment>
          <TranslationsEditingDisabledDiv>
            <SubpageCopyAndDuplicateButtons 
              subpageId={temporarySubpage.id} 
              copyText={<Fragment>
                Copy <Tooltip style={{marginLeft:3,color:'white'}} value={<Fragment>
                  <p><strong>Copy this subpage to your Zoomforth clipboard.</strong></p>
                  <p>This subpage can then be pasted into <em>any site</em> in your account. <strong>To paste this subpage:</strong></p>
                  <Ol>
                    <li>On the left sidebar, click the (▼) next to "+ Subpage"</li>
                    <li>Click "Paste Subpage" <strong>or</strong> click "Clipboard" and paste your subpage from the clipboard modal</li>
                  </Ol>
                </Fragment>} />
                </Fragment>
              }
            />
          </TranslationsEditingDisabledDiv>
          <Divider />
        </Fragment>
    }

    <InputContainerSmartEmptyError 
      dark
      focusOnMount
      name={titleInputName}
      value={title || ''}
      onChange={(e)=> {
        onTitleChange(e.target.value);
      }}
      onEnterKeyUp={(title && isValid) ? onSaveClick : null }
      onEscKeyUp={onCancelClick}
    />

    <TranslateTextWidget 
      text={title}
      onTranslationSave={onTitleChange}
    />

    {children}
  </LinkEditorGenerics>
);

MenuItemEditorGenerics.propTypes = {
  isValid: PropTypes.bool.isRequired,
  title: PropTypes.string,
  titleInputName: PropTypes.string.isRequired,
  canDeleteMenuItem: PropTypes.bool.isRequired,
  deleteText: PropTypes.node.isRequired,
  onTitleChange: PropTypes.func.isRequired, 
  onDeleteClick: PropTypes.func.isRequired,
  onSaveClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired
};

export default MenuItemEditorGenerics;
